import { addChatToSpam, setChatOperationPending } from './actions';
import {
  fetchChatsMoveToSpamDesktop,
  TChatsMoveToSpamDesktopResponse,
} from '../../repositories/chats/v1/chats-move-to-spam-desktop';
import { EAlert } from '../../types/alert';
import { TThunkAction } from '../../types/redux/thunk';
import { showAlert } from '../alert';

/**
 * Пытаемся переместить чат в спам
 */
export const moveToSpam =
  (chatId: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    dispatch(setChatOperationPending(true));

    try {
      const { statusCode, response }: TChatsMoveToSpamDesktopResponse = await fetchChatsMoveToSpamDesktop({
        httpApi,
        parameters: { chatId },
        config: { requestConfig: { withCredentials: true } },
      });

      dispatch(setChatOperationPending(false));

      // @ts-expect-error в модели response не хватает описания 204 ответа
      if (statusCode === 200 || statusCode === 204) {
        dispatch(addChatToSpam(chatId));

        /**
         * При успешном перемещении в спам, показываем алерт отмены
         */
        dispatch(showAlert({ type: EAlert.Spam }));

        return;
      }

      /**
       * При неудачной попытке перенести чат в спам, показываем алерт с ошибкой
       */
      dispatch(showAlert({ message: response.message }));
    } catch (error) {
      logger.error(error, {
        chatId,
        domain: 'frontend-chats.actions.moveToSpam',
        description: 'Ошибка при попытке перенести в спам',
      });

      dispatch(setChatOperationPending(false));
      dispatch(showAlert());
    }
  };
